$(document).ready(function(){
  
  console.log('dev-js-temporary.js ready');

  function adjustPosition() {

    //check if there are any grid item banners on the page

    try {

      // count the number of grid-item-banners on the page
      var numGridItemBanners = $('#CollectionProductGrid .grid-item-banner').length;
  
      // run if there are grid-item-banners on the page 
      if(numGridItemBanners > 0){
        console.log('Adjust Position: grid-item-banners are on the page');
        //find all banners in the collection grid
        
        if($('#CollectionProductGrid .tw-js-move-collection-banner.collection-grid-banner').length){

          console.log('Adjust Position: collection grid banners are on the page');
          
          //for each of the banners, find if there are any grid item banners before it
          $('#CollectionProductGrid .tw-js-move-collection-banner.collection-grid-banner').each(function(){
    
            var $bannerObj = $(this);
  
            // check if there are any grid-item-banners before the collection banner
            if($bannerObj.prevAll('#CollectionProductGrid .grid-item-banner').length){

              console.log('Adjust Position: there are grid item banners before this banner');
              
              // adjust all of the collection item order values before the banner collection-order
              if($bannerObj.prevAll('#CollectionProductGrid .grid-item-banner').length > 0) {

                // set collection order count to 0
                var collectionOrderCount = 0;
                
                // find each grid item banner and increase the collection item values for all following it
                $bannerObj.prevAll('#CollectionProductGrid .grid-item-banner').each(function(){
                  
                  var $gridItemObj = $(this);
                  
                  $gridItemObj.nextAll('[collection-order]').each(function(){

                    var $collectionOrderItem = $(this);

                    console.log('Collection item order: ' + $collectionOrderItem.attr('collection-order'));

                    var newCollectionOrder = parseInt($collectionOrderItem.attr('collection-order'),10) + 1;

                    console.log('Collection item order is now: ' + newCollectionOrder);
                    
                    $collectionOrderItem.attr('collection-order', newCollectionOrder);
                    
                  });
                })
                
              }
  
              // find the number of times the banner type appears before this banner
              var itemAdjustValue = $bannerObj.prevAll('#CollectionProductGrid .grid-item-banner').length;
  
              // set the breakpoint values to insert the banner after - this is the original set value + the number of grid item banners before this banner 
              var breakpoint1 = parseInt($bannerObj.attr('grid-item-breakpoint-1'),10) + parseInt(itemAdjustValue,10);
              var breakpoint2 = parseInt($bannerObj.attr('grid-item-breakpoint-2'),10) + parseInt(itemAdjustValue,10);
              var breakpoint3 = parseInt($bannerObj.attr('grid-item-breakpoint-3'),10) + parseInt(itemAdjustValue,10);
              var breakpoint4 = parseInt($bannerObj.attr('grid-item-breakpoint-4'),10) + parseInt(itemAdjustValue,10);        
  
              // set the new breakpoint values as the banner attributes
              $bannerObj.attr('grid-item-breakpoint-1', breakpoint1);  
              $bannerObj.attr('grid-item-breakpoint-2', breakpoint2);
              $bannerObj.attr('grid-item-breakpoint-3', breakpoint3);
              $bannerObj.attr('grid-item-breakpoint-4', breakpoint4);  
              
            }
            
          });
        
          
        }
        
      }
      
    } catch(adjustPositionErr) {
      console.error('adjustPositionErr: ' + adjustPositionErr.message);
    }
    
  
  }

  function makeAndMoveCollectionBanner() {

    try{
    
      // if there are any collection grid banners on the page run this
      if($('.tw-js-move-collection-banner.collection-grid-banner').length){
  
        // for each existing collection grid banner on the page
        $('.tw-js-move-collection-banner.collection-grid-banner').each(function() {
  
          // take a copy of the banner and set it as the object
          var $bannerObj = $(this).clone();
  
          // set the breakpoint variables from the banner attributes
          var breakpoint1 = $bannerObj.attr('grid-item-breakpoint-1');
          var breakpoint2 = $bannerObj.attr('grid-item-breakpoint-2');
          var breakpoint3 = $bannerObj.attr('grid-item-breakpoint-3');
          var breakpoint4 = $bannerObj.attr('grid-item-breakpoint-4');
  
          // get the window width
          let width = $(window).width();
          console.log('Resizing window: Width is now ' + width);
          
          // move the banner to after the defined collection item from the section settings
          if(width >= 1920){
            $bannerObj.insertAfter('[collection-order='+breakpoint4+']');
          }
          else if (width >= 1536) {
            $bannerObj.insertAfter('[collection-order='+breakpoint3+']');
          }
          else if (width >= 1024) {
            $bannerObj.insertAfter('[collection-order='+breakpoint2+']');
          }      
          else {
            $bannerObj.insertAfter('[collection-order='+breakpoint1+']');
          }
  
          // unhide the banner once it is in it's position
          //$bannerObj.removeClass('tw-hidden');
          
        });
  
      };                                                                
    } catch(moveCollectionBannerErr) {
      console.error('moveCollectionBannerErr: ' + moveCollectionBannerErr.message);
    }  
    
  }

  function initCollectionBanners() {

    //find and delete all previous banners in the grid

    try {

      // find any previously added grid banners
      $('#CollectionProductGrid .tw-js-move-collection-banner').each(function(){

        // delete the banner
        $(this).remove();
        
      });
      
    } catch(initCollectionBannersErr) {
      console.error('initCollectionBannersErr: ' + initCollectionBannersErr.message);
    }
    
  }

  
/**
  function adjustPosition() {
    
      var numGridItemBanners = $('.grid-item-banner').length;

      var counting = 0;
      
      $('.tw-js-move-collection-banner.collection-grid-banner').each(function() {
        var $bannerObj = $(this);

        var defaultGridValues = $bannerObj.attr('grid-item-def-breakpoints');
        var defaultGridValuesArr = defaultGridValues.split(',');

        console.log('defaultGridValues = ' + defaultGridValues + '. Array is ' + defaultGridValuesArr[0] + ' > ' + defaultGridValuesArr[1] + ' > ' +  defaultGridValuesArr[2] + ' > ' +  defaultGridValuesArr[3]);
        
        if($bannerObj.hasClass('full-width-grid-banner')){

          console.log('hey there');
          console.log($bannerObj.prevAll('.grid-item-banner').length);
          if($bannerObj.prevAll('.grid-item-banner').length ){

          var itemAdjustValue = $bannerObj.prevAll('.grid-item-banner').length;
            console.log('itemAdjustValue is ' + itemAdjustValue);
            
          var breakpoint1 = parseInt(defaultGridValuesArr[0],10) + parseInt(itemAdjustValue,10);
          var breakpoint2 = parseInt(defaultGridValuesArr[1],10) + parseInt(itemAdjustValue,10);
          var breakpoint3 = parseInt(defaultGridValuesArr[2],10) + parseInt(itemAdjustValue,10);
          var breakpoint4 = parseInt(defaultGridValuesArr[3],10) + parseInt(itemAdjustValue,10);

          $bannerObj.attr('grid-item-breakpoint-1', breakpoint1);  
          $bannerObj.attr('grid-item-breakpoint-2', breakpoint2);
          $bannerObj.attr('grid-item-breakpoint-3', breakpoint3);
          $bannerObj.attr('grid-item-breakpoint-4', breakpoint4);    

          console.log(`Values adjusted to ${breakpoint1}, ${breakpoint2}, ${breakpoint3}, ${breakpoint4}`);
            
            
          }
          else {
            console.log('no grid item banner before this one');
          }



          



          
        }   
    });
  };

  
  function moveCollectionBanner(){
    
    try {
      
      $('.tw-js-move-collection-banner.collection-grid-banner').each(function() {
        
        var $bannerObj = $(this);

          var breakpoint1 = $bannerObj.attr('grid-item-breakpoint-1');
          var breakpoint2 = $bannerObj.attr('grid-item-breakpoint-2');
          var breakpoint3 = $bannerObj.attr('grid-item-breakpoint-3');
          var breakpoint4 = $bannerObj.attr('grid-item-breakpoint-4');          

        
        if($('.tw-js-move-collection-banner.collection-grid-banner').length){
          console.log('tw-js-move-collection-banner collection-grid-banner exists');
          let width = $(window).width();
          console.log('width is now ' + width);
          if(width >= 1920){
            $bannerObj.insertAfter('[collection-order='+breakpoint4+']');
          }
          else if (width >= 1536) {
            $bannerObj.insertAfter('[collection-order='+breakpoint3+']');
          }
          else if (width >= 1024) {
            $bannerObj.insertAfter('[collection-order='+breakpoint2+']');
          }      
          else {
            $bannerObj.insertAfter('[collection-order='+breakpoint1+']');
          }
    
          $bannerObj.removeClass('tw-hidden');
          
        } 
        
      });
    } catch(moveCollectionBannerErr) {
      console.error('Error: ' + moveCollectionBannerErr.message);
    }
  }

	try {

     if($('.js-ref-code[data-clipboard-text]').length ) {

          if($('.js-ref-code').data('clipboard-text') != "") {
            var datatext = $('.js-ref-code').data('clipboard-text');
            console.log('text is: ' + datatext );
            if(datatext != "##thecode##") {
            console.log('[data-clipboard-text] not empty'); 

            var the_code = $('.js-ref-code').data('clipboard-text');
			  console.log('adding cookie 5722');
            if (the_code.indexOf('myref-') >= 0){
            //Cookies.set('recharge_discount_code', the_code);
            }
          }


        }
     }
  
	} catch (clipboardtext) {
                console.error(clipboardtext.message);
                // expected output: ReferenceError: nonExistentFunction is not defined
                // Note - error messages will vary depending on browser
	}

  
	try {
  
        $('.inject-ref-code').click(function(e) {
          var $thisObj = $(this);


          if($('.js-ref-code[data-clipboard-text]').length ) {

            if($('.js-ref-code').data('clipboard-text') != "") {

              var datatext = $('.js-ref-code').data('clipboard-text');
              console.log('text is: ' + datatext );
              if(datatext != "##thecode##") {            

                var fb_clipboard = new ClipboardJS('[data-clipboard-text]'); 

                fb_clipboard.on('success', function(e) {
                  var dataclipboardtext = $thisObj.attr('data-clipboard-text');
                  if($thisObj.attr('data-clipboard-text') != '') {
                    $thisObj.notify("Copied to clipboard", "success");
                  }
                });

                fb_clipboard.on('error', function(e) {
                  console.log(e);
                });    


                var the_inject_code = $('.inject-ref-code').html();

                console.log('adding cookie 5763');
                Cookies.set('recharge_discount_code', the_inject_code);

              }
            }

          }


        }); 
      
	} catch (injectrefcode) {
                console.error(injectrefcode);
                // expected output: ReferenceError: nonExistentFunction is not defined
                // Note - error messages will vary depending on browser
	}  

  function cartReferralMessage(){
    
      console.log('arrived at referral message');

    console.log('the cookie test code is: ' + Cookies.get('recharge_discount_code'));
    /**
      if(Cookies.get('recharge_discount_code')) {
      var cookie = Cookies.get('recharge_discount_code');
                    console.log('cookie is: ' + cookie );
        console.log('cookie is not blank');

       // $('#cart_referral_message_top').removeClass('tw-hidden').addClass('testingworked');
        $('#cart_referral_message').removeClass('tw-hidden').addClass('testingworked');

        console.log('cart referral message shown');

      }
    else {
        console.log('The cookie didnt exist');
        $('#cart_referral_message').addClass('tw-hidden');
    }
    
  }

  **/

  $(window).on('load', function(){
    initCollectionBanners();
    makeAndMoveCollectionBanner();
    //adjustPosition();
  });
  
  $(window).on('resize', function(){
    console.log('resizing collection window');
    //console.log('width was ' + width);
    initCollectionBanners();
    makeAndMoveCollectionBanner();
    //adjustPosition();
  });

  /**

    try {

        cartReferralMessage();
      
  		$(document).arrive("#cart_referral_message", function() {

          cartReferralMessage();

      	});
  	} catch (cart_referral_messageErr) {
    	console.error(cart_referral_messageErr);
                // expected output: ReferenceError: nonExistentFunction is not defined
                // Note - error messages will vary depending on browser
	}
**/

 	try {

     if($('.js-ref-code[data-clipboard-text]').length ) {

          if($('.js-ref-code').data('clipboard-text') != "") {
            var datatext = $('.js-ref-code').data('clipboard-text');
            console.log('text is: ' + datatext );
            if(datatext != "##thecode##") {
            console.log('[data-clipboard-text] not empty'); 

            var the_code = $('.js-ref-code').data('clipboard-text');
			  console.log('adding cookie '+ the_code);
            if (the_code.indexOf('myref') >= 0)  
            console.log('cookie will contain myref- as it is ' + the_code);
              
            Cookies.set('recharge_discount_code', the_code);
            }
          }


        }
  
	} catch (clipboardtext) {
                console.error(clipboardtext);
                // expected output: ReferenceError: nonExistentFunction is not defined
                // Note - error messages will vary depending on browser
	}

  
	try {
  
        $('.inject-ref-code').click(function(e) {
          var $thisObj = $(this);


          if($('.js-ref-code[data-clipboard-text]').length ) {

            if($('.js-ref-code').data('clipboard-text') != "") {

              var datatext = $('.js-ref-code').data('clipboard-text');
              console.log('text is: ' + datatext );
              if(datatext != "##thecode##") {            

                var fb_clipboard = new ClipboardJS('[data-clipboard-text]'); 

                fb_clipboard.on('success', function(e) {
                  var dataclipboardtext = $thisObj.attr('data-clipboard-text');
                  if($thisObj.attr('data-clipboard-text') != '') {
                    $thisObj.notify("Copied to clipboard", "success");
                  }
                });

                fb_clipboard.on('error', function(e) {
                  console.log(e);
                });    


                var the_inject_code = $('.inject-ref-code').html();

                console.log('adding cookie 5763');
                Cookies.set('recharge_discount_code', the_inject_code);

              }
            }

          }


        }); 
      
	} catch (injectrefcode) {
                console.error(injectrefcode);
                // expected output: ReferenceError: nonExistentFunction is not defined
                // Note - error messages will vary depending on browser
	}




  function cartReferralMessage(){
    
      console.log('arrived at referral message');

      console.log('the cookie test code is: ' + Cookies.get('recharge_discount_code'));
   
      if(Cookies.get('recharge_discount_code')) {
      var cookie = Cookies.get('recharge_discount_code');
                    console.log('cookie is: ' + cookie );
        console.log('cookie is not blank');

        $('#cart_referral_message_top').removeClass('tw-hidden').addClass('testingworked');
        $('#cart_referral_message').removeClass('tw-hidden').addClass('testingworked');

        console.log('cart referral message shown');

      }
    else {
        console.log('The cookie didnt exist');
        $('#cart_referral_message').addClass('tw-hidden');
    }
    
  }

  try {

      cartReferralMessage();
    
      $(document).arrive("#cart_referral_message", function() {

        cartReferralMessage();

      });
  } catch (cart_referral_messageErr) {
      console.error(cart_referral_messageErr);
              // expected output: ReferenceError: nonExistentFunction is not defined
              // Note - error messages will vary depending on browser
  } 


/*   try {

      var bodyID = $('body').attr('id');
      var collectionHandles = 'all-gifts-gift-guide,gifts-for-men,gifts-for-women,gifts-for-kids';

      if (collectionHandles.indexOf(bodyID) > -1) {
        
        console.log('body id is in collectionsHandle');

        $(document).arrive("#endOfPagination", function() {
  
          var giftGuideURL = 'https://www.myoddballs.com/pages/gift-guide .js-all-content';
    
          $('#endOfPagination').load(giftGuideURL, function(){

            $('#endOfPagination').addClass('tw-px-5');  
            $('#endOfPagination').find('.js-content').removeClass('tw-hidden');
            $('#endOfPagination').find('.js-content img').removeClass('lazy tw-hidden');
              
          });
   
        });
  
      } else {
        console.log('body id is not in collectionsHandle');
      };
    
  } catch (moveGiftGuideErr) {
    console.error('moveGiftGuideErr: ' + moveGiftGuideErr.message);
  }
 */
  
  

  
});